export default "__VITE_ASSET__a369d17a__"